import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConGroupItems: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConGroupItemMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConGroupItemsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConGroupItems", null);
            } else {
                dispatch("receivingWebConGroupItems"); // สถานะ กำลังบันทึก


                // axios.get('/web_con_group_items').then(res => {
                //
                //     dispatch("receiveWebConGroupItems", res.data);
                // })
                const formData = new FormData();
                formData.append('group_master_id', payload.group_master_id);
                formData.append('group_sub_a_id', payload.group_sub_a_id);
                formData.append('group_sub_b_id', payload.group_sub_b_id);

                axios.get('/web_con_group_items', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConGroupItems", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConGroupItems", null);
                    });

            }
        },
        loadWebConGroupItemRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConGroupItem", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConGroupItem");
                axios.get('/web_con_group_items/' + id).then(res => {
                    dispatch("receiveWebConGroupItem", res.data);
                })
            }
        },
        updateWebConGroupItemRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConGroupItem");
            const formData = new FormData();

            formData.append('file_fi', payload.avatarFileFi);
            formData.append('group_item_id', payload.group_item_id);
            formData.append('group_sub_b_id', payload.group_sub_b_id);
            formData.append('group_item_index', payload.group_item_index);
            formData.append('group_item_year', payload.group_item_year);
            formData.append('group_item_h_image_th', payload.group_item_h_image_th);
            formData.append('group_item_h_image_en', payload.group_item_h_image_en);
            formData.append('group_item_title_th', payload.group_item_title_th);
            formData.append('group_item_title_en', payload.group_item_title_en);
            formData.append('group_item_content_th', payload.group_item_content_th);
            formData.append('group_item_content_en', payload.group_item_content_en);
            formData.append('status_link', payload.status_link);
            formData.append('group_item_h_file', payload.group_item_h_file);
            formData.append('group_item_h_url', payload.group_item_h_url);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);



             axios.post('/update_con_group_items', formData).then(res => {
                 dispatch("updateWebConGroupItem", res.data);
             })

        },
        createWebConGroupItemRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConGroupItem");

            const formData = new FormData();

            formData.append('file_fi', payload.avatarFileFi);
            formData.append('group_item_id', payload.group_item_id);
            formData.append('group_sub_b_id', payload.group_sub_b_id);
            formData.append('group_item_index', payload.group_item_index);
            formData.append('group_item_year', payload.group_item_year);
            formData.append('group_item_h_image_th', payload.group_item_h_image_th);
            formData.append('group_item_h_image_en', payload.group_item_h_image_en);
            formData.append('group_item_title_th', payload.group_item_title_th);
            formData.append('group_item_title_en', payload.group_item_title_en);
            formData.append('group_item_content_th', payload.group_item_content_th);
            formData.append('group_item_content_en', payload.group_item_content_en);
            formData.append('status_link', payload.status_link);
            formData.append('group_item_h_file', payload.group_item_h_file);
            formData.append('group_item_h_url', payload.group_item_h_url);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('active', payload.active);

            axios.post('/web_con_group_items', formData).then(res => {
                dispatch("receiveWebConGroupItem", res.data);

            })


        },
        deleteWebConGroupItemRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConGroupItem", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConGroupItem", payload);

            axios.post('/delete_con_group_items', payload).then(res => {
                dispatch("deleteWebConGroupItem", {group_item_id: payload.group_item_id, res: res});
            })


        },
        receiveWebConGroupItems({commit}, payload) {
            commit("RECEIVED_CONGROUPITEMS", payload)
        },
        receivingWebConGroupItems({commit}) {
            commit("RECEIVING_CONGROUPITEMS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConGroupItem({commit}, payload) {
            commit("RECEIVED_CONGROUPITEM", payload)
        },
        receivingWebConGroupItem({commit}) {
            commit("RECEIVING_CONGROUPITEMS") //call matutions --> state.isReceiving = true;
        },
        updateWebConGroupItem({commit}, payload) {
            commit("UPDATED_CONGROUPITEM", payload)
        },
        updatingWebConGroupItem({commit}) {
            commit("UPDATING_CONGROUPITEM") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConGroupItem({commit}, payload) {
            commit("DELETED_CONGROUPITEM", payload)
        },
        deletingWebConGroupItem({commit}, payload) {
            commit("DELETING_CONGROUPITEM", payload)
        },
        afterDeleteWebConGroupItem({commit}, payload) {
            commit("AFFTER_DELETED_CONGROUPITEM", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONGROUPITEMS(state, payload) {
            state.webConGroupItems = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONGROUPITEMS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONGROUPITEM(state, payload) {


            if (payload.group_item_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConGroupItemMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConGroupItemMessage: (state.webConGroupItemMessage == webConGroupItemMessage ? webConGroupItemMessage + ' ' : webConGroupItemMessage),

                });
            } else {
                let webConGroupItemMessage = 'บันทึกสำเร็จ! รายการ ' + payload.group_item_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConGroupItems: [...state.webConGroupItems, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConGroupItemMessage: (state.webConGroupItemMessage == webConGroupItemMessage ? webConGroupItemMessage + ' ' : webConGroupItemMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_CONGROUPITEM(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_CONGROUPITEM(state, payload) {
            let index = state.webConGroupItems.findIndex(p => p.group_item_id === payload.group_item_id);
            let webConGroupItemMessage = 'บันทึกสำเร็จ! รายการ ' + payload.group_item_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConGroupItems: state.webConGroupItems.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConGroupItemMessage: (state.webConGroupItemMessage == webConGroupItemMessage ? webConGroupItemMessage + ' ' : webConGroupItemMessage),
            })
        },
        UPDATING_CONGROUPITEM(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONGROUPITEM(state, payload) {


            if (payload.group_item_id == undefined || payload.res.data.message == 'Relation') {
                let webConGroupItemMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.group_item_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConGroupItemMessage: (state.webConGroupItemMessage == webConGroupItemMessage ? webConGroupItemMessage + ' ' : webConGroupItemMessage),

                });
            } else {
                let indexToDelete = state.webConGroupItems.findIndex(p => p.group_item_id === payload.group_item_id);
                let webConGroupItems = [...state.webConGroupItems];
                webConGroupItems.splice(indexToDelete, 1);
                let webConGroupItemMessage = 'บันทึกสำเร็จ! รายการ ' + payload.group_item_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConGroupItems: [...webConGroupItems],
                    isDeleting: false,
                    idToDelete: null,
                    webConGroupItemMessage: (state.webConGroupItemMessage == webConGroupItemMessage ? webConGroupItemMessage + ' ' : webConGroupItemMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONGROUPITEM(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.group_item_id;
        },
        AFFTER_DELETED_CONGROUPITEM(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
